import React from 'react'
import './DataPageCover.scss'
import PropTypes from 'prop-types'

const DataPageCover = props => {
  const navbarHeight = document.querySelector('.js-navbar').clientHeight
  const coverStyle = {
    position: 'relative',
    top: `-${navbarHeight}px`,
    marginBottom: `-${navbarHeight}px`
  }

  return (
    <div className='DataPageCover' style={coverStyle}>
      {props.children}
    </div>
  )
}

DataPageCover.propTypes = {
  children: PropTypes.node
}

export default DataPageCover
